import axios from "axios";
import {
    getDoctorsLink,
    getDoctorDetailsLink,
    getHeader,
    getDoctorBranchesLink,
    getClinicDaysLink,
    getClinicDayTimesLink,
    getDoctorReviews,
    getCurrentBookingFeesLink, getAuthUserFollowedDoctors, citiesUrl, getFollowedDoctorsURL,
} from "./../../config";


import {doctorTypes} from "../types/doctorTypes";
import {types} from "../types/globalTypes";

export const getDoctorsList = (limit = 3) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getDoctorsLink, {limit: limit, sort: 0}, {headers: getHeader()}).then(res => {
            if (res.data.status !== true) {
                const doctors = res.data.Response.data;
                dispatch({
                    type: doctorTypes.GET_DOCTORS_LIST,
                    payload: doctors
                })
            }
        }).catch(err => {
            //console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
};

export const requestDoctorsPage = (page, specialtyString = "", keyword, slug, sort = null, city_id = null, province_id = null) => {

    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        // dispatch start loading
        dispatch({
            type: doctorTypes.FETCHING_MORE_DOCTORS_PAGE,
            payload: true
        });
        // get doctors from server

        let postData = {};
        if (slug && slug !== "") {
            postData.slug = slug
        }
        if (keyword && keyword !== "") {
            postData.keyword = keyword
        }
        if (sort && sort !== "") {
            postData.sort = sort
        }

        if (city_id && city_id !== "") {
            postData.city_id = city_id
        }

        if (province_id && province_id !== "") {
            postData.province_id = province_id
        }

        axios.post(getDoctorsLink + "?page=" + page + "&slug=" + specialtyString, {
            limit: 12,
            ...postData
        }, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                const doctors = res.data.Response;
                dispatch({
                    type: doctorTypes.REQUEST_DOCTORS_PAGE,
                    payload: doctors
                });
                // dispatch end loading
                dispatch({
                    type: doctorTypes.FETCHING_MORE_DOCTORS_PAGE,
                    payload: false
                });
            }
        }).catch(err => {
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });
        });
    }
};

export const applyDoctorSearch = (page, specialtyString = "", keyword, slug, sort) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        // dispatch start loading
        dispatch({
            type: doctorTypes.FETCHING_MORE_DOCTORS_PAGE,
            payload: true
        });
        // get doctors from server
        axios.post(getDoctorsLink + "?page=" + page, {
            limit: 12,
            keyword: keyword,
            slug: slug,
            sort: sort
        }, {headers: getHeader()}).then(res => {
            if (res.data.status !== true) {
                const doctors = res.data.Response;
                dispatch({
                    type: doctorTypes.SEARCH_FOR_DOCTOR,
                    payload: doctors
                });
                // dispatch end loading
                dispatch({
                    type: doctorTypes.FETCHING_MORE_DOCTORS_PAGE,
                    payload: false
                });
            }
        }).catch(err => {
            //console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });

    }
};

export const getAuthFollowedDoctors = (page, specialtyString = "", keyword, slug, sort = null, city_id = null, province_id = null) => {

    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        // dispatch start loading
        dispatch({
            type: doctorTypes.FETCHING_MORE_FOLLOWED_DOCTORS_PAGE,
            payload: true
        });

        // get doctors from server
        let postData = {};
        if (slug && slug !== "") {
            postData.slug = slug
        }
        if (keyword && keyword !== "") {
            postData.keyword = keyword
        }
        if (sort && sort !== "") {
            postData.sort = sort
        }

        if (city_id && city_id !== "") {
            postData.city_id = city_id
        }

        if (province_id && province_id !== "") {
            postData.province_id = province_id
        }

        axios.post(getAuthUserFollowedDoctors + "?page=" + page + "&slug=" + specialtyString, {
            limit: 12,
            ...postData
        }, {headers: getHeader()}).then(res => {

            if (res.data.status !== true) {
                const doctors = res.data.Response;
                dispatch({
                    type: doctorTypes.REQUEST_AUTH_FOLLOWED_DOCTORS_PAGE,
                    payload: doctors
                });
                // dispatch end loading
                dispatch({
                    type: doctorTypes.FETCHING_MORE_FOLLOWED_DOCTORS_PAGE,
                    payload: false
                });
            }
        }).catch(err => {
            //console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
};

export const getDoctorDetails = (id) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getDoctorDetailsLink, {doctor_id: id}, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {

                const doctor = res.data.Response;
                dispatch({
                    type: doctorTypes.GET_DOCTOR_DETAILS,
                    payload: doctor
                });
                // set page title
                    document.title = doctor ? doctor.account_name : "Doctor";
            } else {
                dispatch({
                    type: doctorTypes.CURRENT_DOCTOR_NOT_FOUND,
                    payload: true
                });
            }
        }).catch(err => {
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });

    }
};

export const getDoctorBranches = (id) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getDoctorBranchesLink, {unique_id: id}, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                const branches = res.data.Response;
                dispatch({
                    type: doctorTypes.GET_DOCTOR_BRANCHES,
                    payload: branches
                });
            }
        }).catch(err => {
            console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });

    }
};

export const getDoctorBranchDays = (branch) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getClinicDaysLink, {clinic_id: branch.id, device_token: "BROWSER_TOKEN"}, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                const days = res.data.Response;
                dispatch({
                    type: doctorTypes.GET_BRANCH_DAYS,
                    payload: {
                        currentBranch: branch,
                        days: days
                    }
                });
            }
        }).catch(err => {
            console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });

    }
};

export const getDoctorBranchDayTimes = (day, clinic_id) => {

    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        dispatch({
            type: doctorTypes.CLEAR_CURRENT_DAY,
            payload: null
        });
        axios.post(getClinicDayTimesLink, {clinic_id: clinic_id, day: day.date}).then(res => {
            if (res.data.Error.status === true) {
                const times = res.data.Response;
                dispatch({
                    type: doctorTypes.GET_BRANCH_DAY_TIMES,
                    payload: times
                });
            }
        }).catch(err => {
            console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
};

export const getDoctorBranchDayBreaks = (day, clinic_id) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        dispatch({
            type: doctorTypes.CLEAR_CURRENT_DAY,
            payload: null
        });
        axios.post(getClinicDayTimesLink, {clinic_id: clinic_id, day: day.date}).then(res => {
            if (res.data.Error.status === true) {
                const breaks = res.data.Response;
                dispatch({
                    type: doctorTypes.GET_BRANCH_DAY_BREAKS,
                    payload: breaks
                });
            }
        }).catch(err => {
            console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
};

export const getCurrentBookingFees = (branch, offer = null, type = 0, services =null) => {
    let data = {
        clinic_id: branch.id,
        type: type
    };
    if (services) {
        data.services = services
    }
    if (offer) {
        data.offer_id = offer.id
    }

    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getCurrentBookingFeesLink, data, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                const feesDetails = res.data.Response;
                dispatch({
                    type: doctorTypes.GET_CURRENT_BOOKING_FEES_DETAILS,
                    payload: feesDetails
                });
            } else {
                const error = res.data.Error;
                dispatch({
                    type: doctorTypes.GET_CURRENT_BOOKING_ERROR,
                    payload: error
                });
            }
        }).catch(err => {
            console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
};

export const getCitiesList = () => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.get(citiesUrl, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                dispatch({
                    type: doctorTypes.GET_CITIES_LIST,
                    payload: res.data.Response
                });
            }
        }).catch(err => {
            console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
};

export const getAllDoctorReviews = (doctor_id, limit, offset) => {
    let data = {
        user_id: doctor_id,
        limit: limit,
        offset: offset
    };
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        // dispatch start loading
        dispatch({
            type: doctorTypes.FETCHING_MORE_REVIEWS,
            payload: true
        });
        axios.post(getDoctorReviews, data, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                dispatch({
                    type: doctorTypes.GET_DOCTOR_REVIEWS,
                    payload: res.data.Response
                });
                dispatch({
                    type: doctorTypes.FETCHING_MORE_REVIEWS,
                    payload: false
                });
                if (res.data.Response.length < limit){
                    dispatch({
                        type: doctorTypes.NO_MORE_REVIEWS,
                        payload: true
                    });
                }
            }
        }).catch(err => {
            console.log(err)
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });
    }
}

export const clearReviews = () => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.CLEAR_REVIEWS,
            payload: null,
        })
    }
}
export const clearBookingInfo = () => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.CLEAR_BOOKING_INFO,
            payload: null,
        })
    }
}

export const clearDoctorList = () => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.CLEAR_DOCTOR_LIST,
            payload: []
        });
    }
};

export const clearCurrentDoctor = () => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.CLEAR_CURRENT_DOCTOR,
            payload: null
        });
    }
};

export const getSearchData = (data) => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.GET_SEARCH_DATA,
            payload: data
        });
    }
};

export const setSearchData = (data) => {
    console.log("search data", data);

    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.SET_SEARCH_DATA,
            payload: data
        });
    }
};


export const clearSearchData = () => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.CLEAR_SEARCH_DATA,
            payload: null
        });
    }
};
export const goToDoctorProfileFromBooking = () => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.GO_TO_DOCTOR_PROFILE_FROM_BOOKING,
            payload: true
        });
    }
};
export const clearGoToDoctorProfileFromBooking = () => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.GO_TO_DOCTOR_PROFILE_FROM_BOOKING,
            payload: false
        });
    }
};
export const searchFromFooter = (data) => {
    return (dispatch, getState) => {
        dispatch({
            type: doctorTypes.SEARCH_FROM_FOOTER,
            payload: data
        });
    }
};
